import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';

const styles = {
  container: {
    maxWidth: 480,
    margin: '0 auto',
    background: '#fff',
    minHeight: '100vh',
    paddingBottom: 40,
  },
  header: {
    padding: '1.25rem',
    borderBottom: '1px solid #f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 10,
  },
  backBtn: {
    border: 'none',
    background: 'none',
    fontSize: 15,
    color: '#888',
    padding: 0,
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 600,
  },
  editBtn: {
    border: 'none',
    background: 'none',
    fontSize: 14,
    color: '#007aff',
    padding: 0,
    fontWeight: 500,
  },
  headerDate: {
    fontSize: 12,
    color: '#aaa',
  },
  statsBar: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 8,
    padding: '0.75rem 1.25rem',
    borderBottom: '1px solid #f0f0f0',
  },
  statBox: {
    background: '#f8f8f8',
    borderRadius: 8,
    padding: '8px 10px',
  },
  statLabel: {
    fontSize: 10,
    color: '#888',
    marginBottom: 2,
  },
  statValue: {
    fontSize: 14,
    fontWeight: 600,
  },
  metaRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem 1.25rem',
    borderBottom: '1px solid #f0f0f0',
    fontSize: 13,
    color: '#888',
  },
  metaValue: {
    fontWeight: 600,
    color: '#1a1a1a',
  },
  metaInput: {
    border: '1px solid #ebebeb',
    borderRadius: 8,
    padding: '5px 10px',
    fontSize: 13,
    width: 80,
    textAlign: 'center',
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: '#888',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    padding: '1.25rem 1.25rem 0.5rem',
  },
  exerciseList: {
    padding: '0 1.25rem',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  exerciseCard: {
    border: '1px solid #ebebeb',
    borderRadius: 12,
    overflow: 'hidden',
  },
  exerciseHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 12px',
    background: '#f8f8f8',
  },
  exerciseName: {
    fontSize: 14,
    fontWeight: 600,
  },
  exerciseVol: {
    fontSize: 12,
    color: '#888',
  },
  colHeaders: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr 1fr 60px',
    padding: '4px 12px',
  },
  colLabel: {
    fontSize: 11,
    color: '#aaa',
    textAlign: 'center',
  },
  setRow: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr 1fr 60px',
    alignItems: 'center',
    padding: '6px 12px',
    borderTop: '1px solid #f5f5f5',
  },
  setNum: {
    fontSize: 12,
    color: '#aaa',
  },
  setVal: {
    fontSize: 13,
    textAlign: 'center',
    color: '#1a1a1a',
  },
  setInput: {
    border: '1px solid #ebebeb',
    borderRadius: 6,
    padding: '5px 4px',
    fontSize: 13,
    textAlign: 'center',
    width: '85%',
    margin: '0 auto',
    display: 'block',
    background: '#fff',
  },
  setVol: {
    fontSize: 12,
    color: '#aaa',
    textAlign: 'center',
  },
  saveEditsBtn: {
    display: 'block',
    width: 'calc(100% - 2.5rem)',
    margin: '1.5rem 1.25rem 0',
    padding: '14px',
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    background: '#1a1a1a',
    border: 'none',
    borderRadius: 12,
    textAlign: 'center',
  },
  deleteBtn: {
    display: 'block',
    width: 'calc(100% - 2.5rem)',
    margin: '0.75rem 1.25rem 0',
    padding: '14px',
    fontSize: 14,
    fontWeight: 500,
    color: '#c0392b',
    background: '#fff5f5',
    border: '1px solid #f5c0c0',
    borderRadius: 12,
    textAlign: 'center',
  },
  confirmOverlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 100,
  },
  confirmSheet: {
    background: '#fff',
    width: '100%',
    maxWidth: 480,
    borderRadius: '16px 16px 0 0',
    padding: '1.5rem 1.25rem 2rem',
  },
  confirmTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 6,
  },
  confirmSubtitle: {
    fontSize: 13,
    color: '#888',
    marginBottom: '1.25rem',
  },
  confirmDeleteBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    marginBottom: 8,
    border: 'none',
    borderRadius: 10,
    background: '#c0392b',
    color: '#fff',
    fontSize: 15,
    fontWeight: 600,
    textAlign: 'center',
  },
  confirmCancelBtn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    border: 'none',
    borderRadius: 10,
    background: '#f5f5f5',
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
  },
  empty: {
    textAlign: 'center',
    padding: '3rem',
    color: '#aaa',
    fontSize: 14,
  },
};

export default function SessionDetailScreen({ sessionId, onBack }) {
  const [session, setSession] = useState(null);
  const [groupedSets, setGroupedSets] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editedSets, setEditedSets] = useState({});
  const [editedBodyMass, setEditedBodyMass] = useState('');
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [saving, setSaving] = useState(false);

  const loadSession = useCallback(() => {
    api.get(`/sessions/${sessionId}`).then(r => {
      setSession(r.data);
      const groups = {};
      r.data.sets.forEach(s => {
        if (!groups[s.exercise_name]) groups[s.exercise_name] = [];
        groups[s.exercise_name].push(s);
      });
      setGroupedSets(Object.entries(groups));

      // Initialize edit state
      const edits = {};
      r.data.sets.forEach(s => {
        edits[s.id] = { weight: s.weight, reps: s.reps };
      });
      setEditedSets(edits);
      setEditedBodyMass(r.data.body_mass || '');
    });
  }, [sessionId]);

  useEffect(() => { loadSession(); }, [sessionId, loadSession]);



  const formatDuration = (secs) => {
    if (!secs) return '—';
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}m ${s}s`;
  };

  const getVol = (weight, reps) => {
    const v = parseFloat(weight) * parseInt(reps);
    return isNaN(v) ? '—' : v.toLocaleString();
  };

  const exerciseVol = (sets) => {
    const total = sets.reduce((sum, s) => {
      const w = editMode ? parseFloat(editedSets[s.id]?.weight) : s.weight;
      const r = editMode ? parseInt(editedSets[s.id]?.reps) : s.reps;
      return sum + (isNaN(w * r) ? 0 : w * r);
    }, 0);
    return total.toLocaleString();
  };

  const handleSaveEdits = async () => {
    setSaving(true);
    const allSets = groupedSets.flatMap(([, sets]) => sets);
    for (const s of allSets) {
      const edited = editedSets[s.id];
      if (edited) {
        await api.patch(`/sets/${s.id}`, {
          exercise_id: s.exercise_id,
          set_number: s.set_number,
          weight: parseFloat(edited.weight),
          reps: parseInt(edited.reps),
        });
      }
    }
    await api.patch(`/sessions/${sessionId}`, {
      ...(editedBodyMass !== '' && { body_mass: parseFloat(editedBodyMass) }),
    });
    await loadSession();
    setEditMode(false);
    setSaving(false);
  };

  const handleDelete = async () => {
    setDeleting(true);
    await api.delete(`/sessions/${sessionId}`);
    setDeleting(false);
    onBack();
  };

  if (!session) return <div style={styles.empty}>Loading...</div>;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Back</button>
        <span style={styles.headerTitle}>{session.workout_type_name || 'Workout'} Day</span>
        <button style={styles.editBtn} onClick={() => setEditMode(!editMode)}>
          {editMode ? 'Cancel' : 'Edit'}
        </button>
      </div>

      <div style={styles.statsBar}>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Total weight</div>
          <div style={styles.statValue}>{session.total_weight?.toLocaleString()} lbs</div>
        </div>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Total reps</div>
          <div style={styles.statValue}>{session.total_reps}</div>
        </div>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Avg / rep</div>
          <div style={styles.statValue}>{session.avg_per_rep} lbs</div>
        </div>
      </div>

      <div style={styles.metaRow}>
        <span>Duration</span>
        <span style={styles.metaValue}>{formatDuration(session.duration_seconds)}</span>
      </div>

      <div style={styles.metaRow}>
        <span>Body mass</span>
        {editMode ? (
          <input
            style={styles.metaInput}
            type="number"
            value={editedBodyMass}
            onChange={e => setEditedBodyMass(e.target.value)}
            placeholder="lbs"
          />
        ) : (
          <span style={styles.metaValue}>
            {session.body_mass ? `${session.body_mass} lbs` : '—'}
          </span>
        )}
      </div>

      <div style={styles.sectionLabel}>Exercises</div>

      {groupedSets.length === 0 && (
        <div style={styles.empty}>No sets logged for this session.</div>
      )}

      <div style={styles.exerciseList}>
        {groupedSets.map(([exerciseName, sets]) => (
          <div key={exerciseName} style={styles.exerciseCard}>
            <div style={styles.exerciseHeader}>
              <span style={styles.exerciseName}>{exerciseName}</span>
              <span style={styles.exerciseVol}>{exerciseVol(sets)} lbs total</span>
            </div>
            <div style={styles.colHeaders}>
              <span style={{ ...styles.colLabel, textAlign: 'left' }}>Set</span>
              <span style={styles.colLabel}>Weight</span>
              <span style={styles.colLabel}>Reps</span>
              <span style={styles.colLabel}>Vol</span>
            </div>
            {sets.map((s, i) => (
              <div key={s.id} style={styles.setRow}>
                <span style={styles.setNum}>{i + 1}</span>
                {editMode ? (
                  <>
                    <input
                      style={styles.setInput}
                      type="number"
                      value={editedSets[s.id]?.weight ?? s.weight}
                      onChange={e => setEditedSets(prev => ({
                        ...prev,
                        [s.id]: { ...prev[s.id], weight: e.target.value }
                      }))}
                    />
                    <input
                      style={styles.setInput}
                      type="number"
                      value={editedSets[s.id]?.reps ?? s.reps}
                      onChange={e => setEditedSets(prev => ({
                        ...prev,
                        [s.id]: { ...prev[s.id], reps: e.target.value }
                      }))}
                    />
                  </>
                ) : (
                  <>
                    <span style={styles.setVal}>{s.weight} lbs</span>
                    <span style={styles.setVal}>{s.reps}</span>
                  </>
                )}
                <span style={styles.setVol}>
                  {editMode
                    ? getVol(editedSets[s.id]?.weight, editedSets[s.id]?.reps)
                    : getVol(s.weight, s.reps)}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>

      {editMode && (
        <button style={styles.saveEditsBtn} onClick={handleSaveEdits} disabled={saving}>
          {saving ? 'Saving...' : 'Save changes'}
        </button>
      )}

      <button style={styles.deleteBtn} onClick={() => setShowConfirmDelete(true)}>
        Delete this session
      </button>

      {showConfirmDelete && (
        <div style={styles.confirmOverlay} onClick={() => setShowConfirmDelete(false)}>
          <div style={styles.confirmSheet} onClick={e => e.stopPropagation()}>
            <div style={styles.confirmTitle}>Delete this session?</div>
            <div style={styles.confirmSubtitle}>
              This will permanently delete all sets and data for this workout. This cannot be undone.
            </div>
            <button style={styles.confirmDeleteBtn} onClick={handleDelete} disabled={deleting}>
              {deleting ? 'Deleting...' : 'Yes, delete session'}
            </button>
            <button style={styles.confirmCancelBtn} onClick={() => setShowConfirmDelete(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}